import { render } from "./AdminManual.vue?vue&type=template&id=96884544&scoped=true"
import script from "./AdminManual.vue?vue&type=script&lang=js"
export * from "./AdminManual.vue?vue&type=script&lang=js"

import "./AdminManual.vue?vue&type=style&index=0&id=96884544&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96884544"]])

export default __exports__